package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.SavedClient
import br.com.heyagenda.domain.repository.ClientRepository
import kotlinx.coroutines.flow.Flow

class GetSavedClientsUseCase(
    private val repository: ClientRepository
) {
    operator fun invoke(): Flow<List<SavedClient>> {
        return repository.getSavedClients()
    }
}
